import { useEffect } from "react";
import Lenis from "lenis";
import { motion, useScroll } from "framer-motion";
import Navbar from "./Navbar";
import Hero from "./Hero";
import Consulenza from "./Consulenza";
import Problems from "./Problems";
import Timeline from "./Timeline";
import Stats from "./Stats";
import Difference from "./Difference";
import MesSection from "./MesSection";
import CaseStudies from "./CaseStudies";
import International from "./International";
import Contact from "./Contact";
import Footer from "./Footer";
import { FloatingWhatsApp } from "./WhatsApp";

export default function HomePage() {
    const { scrollYProgress } = useScroll();

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        const onClick = (e) => {
            const anchor = e.target.closest('a[href^="#"]');
            if (!anchor) return;
            const id = anchor.getAttribute("href");
            if (id && id.length > 1 && document.querySelector(id)) {
                e.preventDefault();
                lenis.scrollTo(id, { offset: -72 });
            }
        };
        document.addEventListener("click", onClick);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            document.removeEventListener("click", onClick);
        };
    }, []);

    return (
        <>
            <motion.div
                className="fixed left-0 right-0 top-0 z-[60] h-0.5 origin-left bg-sky-400"
                style={{ scaleX: scrollYProgress }}
            />
            <Navbar />
            <main>
                <Hero />
                <Consulenza />
                <Problems />
                <Timeline />
                <Stats />
                <Difference />
                <MesSection />
                <CaseStudies />
                <International />
                <Contact />
            </main>
            <Footer />
            <FloatingWhatsApp />
        </>
    );
}
